export default __webpack_public_path__ + "static/src/assets/images/icons/mobiles/market_icon_watchlist@2x.png";